module.exports = __webpack_public_path__ + "static/media/07_atw_weihnachtskarte_rueckseite.c6e71585.svg";